<template>
  <div class="videos" :class="{ 'videos--dark': darkMode }">
    <div class="banner-section">
      <h2 class="section-title">Materiały archiwalne OTvK</h2>
    </div>
    <div class="videos-section container">
      <videos-list
        :tags="tags"
        :videos="videos"
        :page="page"
        :dark="darkMode"
        :search.sync="query"
        :pageable="pageable"
        :state="actions.videos"
        :is-searching="isSearching"
        :videos-state="actions.videos"
        @select-video="selectVideo"
        @toggle-tag-selection="toggleTagSelection"
        @select-tag="selectTag"
        @clear-selected-tags="clearSelectedTags"
        @change-page="changePage"
        @switch-dark-mode="switchDarkMode"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { FETCH_VIDEOS, FETCH_TAGS } from ":actions";
import {
  SELECT_TAG,
  TOGGLE_TAG_SELECTION,
  CLEAR_SELECTED_TAGS,
  SWITCH_DARK_MODE
} from ":mutations";

import VideosList from "%components/videos/VideosList";

import { debounce } from "%utils/functions";

import { omit } from "%utils/object";

import { WithDispatcherProgress } from "%mixins";

export default {
  name: "videos",

  components: {
    VideosList
  },

  mixins: [WithDispatcherProgress],

  props: {
    page: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      query: "",
      isSearching: false
    };
  },

  computed: {
    ...mapState({
      videos: state => state.videos.videos.content,
      pageable: state => omit(state.videos.videos, "content"),
      darkMode: state => state.videos.darkMode
    }),

    ...mapGetters({
      tags: "selectedTagsOnTop"
    })
  },

  beforeMount() {
    this.fetchTags();
    this.fetchVideos();
  },

  methods: {
    async selectVideo(video) {
      await this.$router.push({
        name: "video",
        params: {
          videoId: video.id
        }
      });
      this.$immediatelyScrollToTop();
    },

    selectTag(tag) {
      this.$store.commit(SELECT_TAG, { tag });
      this.changePage(1);
      this.fetchVideos();
    },

    toggleTagSelection(tag) {
      this.$store.commit(TOGGLE_TAG_SELECTION, { tag });
      this.changePage(1);
      this.fetchVideos();
    },

    clearSelectedTags() {
      this.$store.commit(CLEAR_SELECTED_TAGS);
      this.fetchVideos();
    },

    switchDarkMode(darkMode) {
      this.$store.commit(SWITCH_DARK_MODE, { darkMode });
    },

    async changePage(page) {
      if (this.page !== page) {
        await this.$router.push({
          name: "videos",
          query: {
            ...this.$route.query,
            page
          }
        });

        await this.$scrollTo(".videos-container", { offset: -170 }, 100);
        this.fetchVideos();
      }
    },

    fetchVideos() {
      this.dispatchWithProgress("videos", FETCH_VIDEOS, {
        page: this.page,
        query: this.query === "" ? undefined : this.query,
        size: 12
      }).then(() => setTimeout((this.isSearching = false), 100));
    },

    debouncedSearch: debounce(function() {
      this.fetchVideos();
    }, 500),

    fetchTags() {
      this.$store.dispatch(FETCH_TAGS);
    }
  },

  watch: {
    query() {
      this.isSearching = true;
      this.changePage(1);
      this.debouncedSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.videos {
  background: url(../assets/img/bubbles.svg) no-repeat center / cover,
    linear-gradient(10deg, $info, $primary, $primary2);
  padding: 5rem 0;
}

.search-card {
  margin-bottom: 5rem;
}

.videos--dark {
  &.videos {
    background: url(../assets/img/bubbles-dark.svg) no-repeat center / cover,
      $black;
    min-height: 120vh;
    padding-bottom: 5rem;
  }
}
</style>
